import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  getPayment = "/payment";
  getPaymentTEST = "/payment2";
  getPaymentV2 = "/payments/v2/dashboard-details";
  addPayment = "/payment";
  constructor(private http: HttpClient) { }

  getPaymentDetails(apptId: any, fromDate: any, toDate: any) {
    let params = new HttpParams();
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }

    if (fromDate != null) {
      params = params.append('fromDate', fromDate);
    }
    if (toDate != null) {
      params = params.append('toDate', toDate);
    }

    return this.http.get<any>(`${this.getPayment}`, { params: params })
  }

  getPaymentDetailsV2(apptId: any, fromDate: any, toDate: any) {
    let params = new HttpParams();
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }

    if (fromDate != null) {
      params = params.append('fromDate', fromDate);
    }
    if (toDate != null) {
      params = params.append('toDate', toDate);
    }

    return this.http.get<any>(`${this.getPaymentV2}`, { params: params })
  }


  addPaymentDetails(apptId: any, amount: any, miscAdjustment: any, depositeAdjustment: any) {
    let params = new HttpParams();
    if (apptId != null) {
      params = params.append('appointmentId', apptId);
    }
    

    if (amount && amount != null) {
      params = params.append('payment', amount);
    } else {
      params = params.append('payment', '0.0');
    }

    // if ( amount != null && amount.length > 0) {
    //   params = params.append('payment', amount);
    // } else {
    //   params = params.append('payment', '0.0');
    // }
    if (miscAdjustment != null && miscAdjustment.length > 0) {
      params = params.append('miscAdjustment', miscAdjustment);
    } else {
      params = params.append('miscAdjustment', '0.0');
    }

    if (depositeAdjustment != null && depositeAdjustment.length > 0) {
      params = params.append('depositeAdjustment', depositeAdjustment);
    } else {
      params = params.append('depositeAdjustment', '0.0');
    }
    
   // return this.http.put<any>(`${this.getPaymentTEST}`, "", { params: params })
    return this.http.put<any>(`${this.getPayment}`, "", { params: params })
  }
}
